import React from 'react';
import Select from 'react-select';

const CUSTOM_PERIOD_OPTIONS = [
  { label: 'Data customizada', value: 'costumizado' },
  { label: 'Ultimas 24 horas', value: '1' },
  { label: 'Ultimos 7 dias', value: '7' },
  { label: 'Ultimos 15 dias', value: '15' },
  { label: 'Ultimos 30 dias', value: '30' },
];

const CustomPeriod = ({ changePeriod, customPeriodOption }) => {
  const changeSelect = (option) => {
    const startDate = new Date();
    if (option.value === '1') {
      const endDate = new Date(new Date().setDate(startDate.getDate() - 1));
      changePeriod(endDate, startDate, 1);
    } else if (option.value === '7') {
      const endDate = new Date(new Date().setDate(startDate.getDate() - 7));
      changePeriod(endDate, startDate, 2);
    } else if (option.value === '15') {
      const endDate = new Date(new Date().setDate(startDate.getDate() - 15));
      changePeriod(endDate, startDate, 3);
    } else if (option.value === '30') {
      const endDate = new Date(new Date().setDate(startDate.getDate() - 30));
      changePeriod(endDate, startDate, 4);
    } else if (option.value === 'costumizado') {
      changePeriod(null, null, 0);
    }
  };

  return (
    <Select
      className="audit-react-select-custom-period"
      classNamePrefix="audit-react-select-custom-period"
      defaultValue={CUSTOM_PERIOD_OPTIONS[0]}
      options={CUSTOM_PERIOD_OPTIONS}
      onChange={changeSelect}
      value={CUSTOM_PERIOD_OPTIONS[customPeriodOption]}
      theme={(theme) => ({
        ...theme,
        borderRadius: 5,
        colors: {
          ...theme.colors,
          primary: '#5e6876',
          primary25: '#D7DADB',
          neutral80: '#515f75',
          neutral10: '#a8b1bf',
        },
      })}
    />
  );
};

export default CustomPeriod;
